export function generateSheetHeaders(quantity) {
  const source = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const headers = source
    .split('')
    .slice(0, quantity)
    .map((e) => `Coluna ${e}`);

  return headers;
}
